module.exports = __webpack_public_path__ + "img/hr-tree-06-j-trunk.486b172c.png";